<template>
  <!--mine-card-->
  <div class="card mine-card" :style="{ minHeight: height + 'px', width: width + '%'}">
    <card-title
      style="padding-bottom: 0 !important;"
      class="p-l-12 p-r-12 p-t-12"
      :type="type"
      :title="title"
      :is-more="isMore"
      :commodity-arr="commodityArr"
      :linear-top-color="linearTopColor"
      :linear-bottom-color="linearBottomColor"
      :text-more="textMore"
      :font-size="fontSize"
    >
    </card-title>
    <tk-flex wrap class="p-y-12">
      <tk-flex
        center
        class="tk-grid-3"
        column
        v-for="(s, index) in commodityArr"
        @click.native="nextPage(s)"
        :class="{'m-t-30': index > 3}"
        :key="index"
      >
        <div>
          <div v-if="type === 'myOrder' || type === 'mineFeatures'">
            <tkui-badge :value="waitOrderVal" v-if="type === 'myOrder'
             && waitOrderVal > 0 && s.icon === 'pendingpayment'">
              <tk-icon size="24">{{s.icon}}</tk-icon>
            </tkui-badge>
            <tkui-badge :value="tobereceivedVal" v-else-if="type === 'myOrder'
             && tobereceivedVal > 0 && s.icon === 'tobereceived'">
              <tk-icon size="24">{{s.icon}}</tk-icon>
            </tkui-badge>
            <tkui-badge :value="evaluatedVal" v-else-if="type === 'myOrder'
             && evaluatedVal > 0 && s.icon === 'tobecommented'">
              <tk-icon size="24">{{s.icon}}</tk-icon>
            </tkui-badge>
            <tkui-badge :value="returnVal" v-else-if="type === 'myOrder'
             && returnVal > 0 && s.icon === 'returnExchange'">
              <tk-icon size="24">{{s.icon}}</tk-icon>
            </tkui-badge>
            <tk-icon v-else>{{s.icon}}</tk-icon>
          </div>
          <div v-if="type === 'clientOrder'">
            <tkui-badge :value="waitClientVal" v-if="type === 'clientOrder'
             && waitClientVal > 0 && s.pathType === 'toBeShipped'">
              <tk-avatar size="32">
                <tk-image :src="s.image" height="32" width="32"></tk-image>
              </tk-avatar>
            </tkui-badge>
            <tkui-badge :value="returnClientVal" v-else-if="type === 'clientOrder'
             && returnClientVal > 0 && s.pathType === 'returnExchange'">
              <tk-avatar size="32">
                <tk-image :src="s.image" height="32" width="32"></tk-image>
              </tk-avatar>
            </tkui-badge>
            <tk-avatar v-else size="32">
              <tk-image :src="s.image" height="32" width="32"></tk-image>
            </tk-avatar>
          </div>
          <div class="font-bold font-20" v-if="type === 'wallet'">{{s.number}}</div>
        </div>
       <div class="font-12" style="padding-top: 7px;">{{s.text}}</div>
      </tk-flex>
    </tk-flex>
    <slot></slot>
  </div>
</template>

<script>
import cardTitle from '@/components/cardTitle'
export default {
  components: {
    cardTitle
  },
  props: {
    width: {
      type: Number
    },
    height: {
      type: Number
    },
    title: {
      type: String
    },
    type: {
      type: String
    },
    commodityArr: {
      type: Array
    },
    isMore: {
      type: Boolean,
      default: false
    },
    linearTopColor: {
      type: String,
      default: ''
    },
    linearBottomColor: {
      type: String,
      default: ''
    },
    textMore: {
      type: String,
      default: '查看全部'
    },
    fontSize: {
      type: Number,
      default: 14
    }
  },
  data () {
    return {
      waitClientVal: 0, // 客户订单待发货val
      returnClientVal: 0, // 客户订单退换货val
      waitOrderVal: 0, // 待付款订单角标
      tobereceivedVal: 0, // 待评价角标
      evaluatedVal: 0, // 待评价角标
      returnVal: 0 // 退换货角标
    }
  },
  computed: {
  },
  async activated () {
    switch (this.type) {
      case 'myOrder': // 我的订单
        this.waitOrderVal = await this.statisticsNum('order', {
          buyUser: this.userInfo.objectId,
          status: {
            $in: ['pendingPayment']
          }
        })
        this.tobereceivedVal = await this.statisticsNum('order', {
          buyUser: this.userInfo.objectId,
          status: {
            $in: ['pendingReceipt']
          }
        })
        this.evaluatedVal = await this.statisticsNum('order', {
          buyUser: this.userInfo.objectId,
          status: {
            $in: ['toBeEvaluated']
          }
        })
        this.returnVal = await this.statisticsNum('order', {
          buyUser: this.userInfo.objectId,
          status: {
            $in: ['returnExchange']
          }
        })
        break
      case 'clientOrder': // 客户订单
        this.waitClientVal = await this.statisticsNum('order', {
          merchants: this.userInfo.objectId,
          status: {
            $in: ['toBeShipped']
          }
        })
        this.returnClientVal = await this.statisticsNum('order', {
          merchants: this.userInfo.objectId,
          status: {
            $in: ['returnExchange']
          }
        })
        break
    }
  },
  methods: {
    /**
    * 跳到下一个页面
    * @date: 2020/4/14
    */
    nextPage (s) {
      switch (this.type) {
        case 'myOrder': // 我的订单
          // 待付款
          if (s.pathType === 'pendingpayment') { this.$push({ path: '/order/myOrderList', query: { tabIndex: '1', type: this.type, list: true } }) }
          // 待收货
          if (s.pathType === 'tobereceived') { this.$push({ path: '/order/myOrderList', query: { tabIndex: '2', type: this.type, list: true } }) }
          // 待评价
          if (s.pathType === 'toBeEvaluated') { this.$push({ path: '/order/myOrderList', query: { tabIndex: '3', type: this.type, list: true } }) }
          // 退换货
          if (s.pathType === 'returnExchange') { this.$push({ path: '/order/myOrderList', query: { tabIndex: '4', type: this.type, list: true } }) }
          break
        case 'clientOrder': // 客户订单
          // 待发货
          if (s.pathType === 'toBeShipped') { this.$push({ path: '/order/clientOrderList', query: { tabIndex: '1', type: this.type, list: true } }) }
          // 已发货
          if (s.pathType === 'pendingReceipt') { this.$push({ path: '/order/clientOrderList', query: { tabIndex: '2', type: this.type, list: true } }) }
          // 已评价
          if (s.pathType === 'completed') { this.$push({ path: '/order/clientOrderList', query: { tabIndex: '3', type: this.type, list: true } }) }
          // 退换货
          if (s.pathType === 'returnExchange') { this.$push({ path: '/order/clientOrderList', query: { tabIndex: '4', type: this.type, list: true } }) }
          break
        case 'wallet': // 我的钱包
          // 欢乐豆
          if (s.pathType === 'happyBean') { this.$push('/itsMine/myHappyBean') }
          // 幸运星
          if (s.pathType === 'luckyStar') { this.$push('/signLottery/checkPage') }
          // 优惠券
          if (s.pathType === 'couponIssues') { this.$push({ path: '/itsMine/myVouchers', query: { type: 'coupons', isSelected: false } }) }
          // 运费券
          if (s.pathType === 'freightVouchers') { this.$push({ path: '/itsMine/myVouchers', query: { type: 'freightVouchers', isSelected: false } }) }
          break
        case 'mineFeatures': // 我的功能
          // 我的销量
          if (s.pathType === 'sales') { this.$push('/itsMine/mySales') }
          // 我的客户
          if (s.pathType === 'myclient') { this.$push('/itsMine/myClient') }
          // 重要通知
          if (s.pathType === 'importantnotice') { this.$push({ path: '/common/articlePage', query: { type: 'importantNotice' } }) }
          // 常见问题
          if (s.pathType === 'problem') { this.$push('/itsMine/commonProblem') }
          // 在线客服
          if (s.pathType === 'onlineservice') { this.$push('/common/customerService') }
          // 意见建议
          if (s.pathType === 'comment') { this.$push('/itsMine/feedBack') }
          // 联系我们
          if (s.pathType === 'lianxiwomen') { this.$push('/itsMine/contactUs') }
          // 关于我们
          if (s.pathType === 'guanyuwomen') { this.$push('/itsMine/aboutUs') }
          // 我的收藏
          if (s.pathType === 'mycollection') { this.$push('/itsMine/myCollection') }
          // 地址管理
          if (s.pathType === 'addressmanagement') { this.$push('/itsMine/shippingAddress') }
          if (s.pathType === 'protocol') { this.$push('/itsMine/protocol') }
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .card {
    border-radius: 10px;
    background: #fff;
    overflow: hidden;
  }
  .mine-card {
    ::v-deep .tkui-badge .tkui-badge-wrapper {
      right: -12px !important;
    }
  }
</style>
